/* eslint-disable @typescript-eslint/naming-convention */
import { Pipe, PipeTransform } from '@angular/core';
import { MeetingRecurrence } from 'lfx-pcc';
import { DateTime } from 'luxon';

@Pipe({
  name: 'recurrence',
  standalone: true,
})
export class RecurrencePipe implements PipeTransform {
  public transform(value: MeetingRecurrence): unknown {
    if (!value) {
      return 'No recurrence information provided';
    }

    const { end_date_time, end_times, monthly_day, monthly_week, monthly_week_day, repeat_interval, type, weekly_days } = value;
    let description = '';

    switch (type) {
      case 1: // Daily
        if (weekly_days) {
          description += `Every ${this.getWeekDays(weekly_days)}`;
        } else {
          description += `Daily meeting`;
        }
        break;
      case 2: // Weekly
        description += `Weekly meeting on ${this.getWeekDays(weekly_days as string)}`;
        break;
      case 3: // Monthly
        if (monthly_day) {
          description += `Monthly meeting on day ${monthly_day}`;
        } else if (monthly_week && monthly_week_day) {
          description += `Monthly meeting on ${this.getMonthlyWeek(monthly_week)} ${this.getWeekDay(monthly_week_day)}`;
        }
        break;
      default:
        description += 'Invalid meeting type';
    }

    if (repeat_interval && type !== 1) {
      description += ` every ${repeat_interval} ${type === 2 ? 'week(s)' : 'month(s)'}`;
    }

    if (end_date_time) {
      const endDateTime = DateTime.fromISO(end_date_time);
      if (endDateTime.isValid && endDateTime.diffNow().years > 5) {
        description += ` until ${DateTime.fromISO(end_date_time).toLocaleString(DateTime.DATE_MED)}`;
      }
    } else if (end_times) {
      description += `, for ${end_times} occurrence(s)`;
    }

    return description;
  }

  private getWeekDays(weekly_days: string): string {
    return weekly_days
      .split(',')
      .map((day) => this.getDaysMap()[day])
      .join(', ');
  }

  private getMonthlyWeek(monthly_week: number): string {
    const weekMap: { [key: string]: string } = { '-1': 'last', '1': 'first', '2': 'second', '3': 'third', '4': 'fourth' };
    return weekMap[monthly_week.toString()];
  }

  private getWeekDay(day: number): string {
    return this.getDaysMap()[day];
  }

  private getDaysMap(): { [key: string]: string } {
    return {
      '1': 'Sunday',
      '2': 'Monday',
      '3': 'Tuesday',
      '4': 'Wednesday',
      '5': 'Thursday',
      '6': 'Friday',
      '7': 'Saturday',
    };
  }
}
